import type { EmptyPrefetchProps } from '#src/shared/prefetch';
import { withPrefetchedData } from '#src/shared/prefetch';

import { OG_IMAGE } from '#src/app/pages/about/main/shared/consts';

import { Layout } from '../layout';

export const About = withPrefetchedData(
	function About(_props: EmptyPrefetchProps) {
		return <Layout />;
	},
	{
		prefetchName: __MODULE_HASH__,
		pageTitle: ({ i18n, fromTemplate }) => fromTemplate(i18n.translate('fe.pages.about.title_tag')),
		pageMetadata: ({ i18n, getStaticAssetUrl }) => {
			const title = i18n.translate('fe.pages.about.title_tag');
			const description = i18n.translate('fe.pages.about.description_tag');
			return {
				description,
				ogTitle: title,
				ogDescription: description,
				ogImage: getStaticAssetUrl(OG_IMAGE),
				ogType: 'website',
				twitterCard: 'summary',
				twitterImage: getStaticAssetUrl(OG_IMAGE),
				twitterImageAlt: title,
			};
		},
	},
);
